export default "__VITE_ASSET__f8c41690__"